import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../core/abstractions/base.component';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { concatMap, map, zip } from 'rxjs';
import { COMPANIES_COLLECTION, OP_EQUALS, USERS_COLLECTION } from '../../../../app.constants';
import { AuthFirebaseService } from '../../../../core/services/auth-firebase.service';
import { UserService } from '../../../../core/services/user.service';
import { untilDestroyed } from '@ngneat/until-destroy';

@Component({
  selector: 'app-cop-broker-helper',
  templateUrl: './cop-broker-helper.component.html',
  styleUrl: '../cop-helper.component.scss'
})
export class CopBrokerHelperComponent extends BaseComponent implements OnInit {
  loadingEmployees = false;
  companies: any[] = [];

  constructor(
    private firestore: AngularFirestore,
    private auth: AuthFirebaseService,
    private userService: UserService
  ) {
    super();
  }

  override ngOnInit(): void {
    this.loadingEmployees = true;
    this.spinner.show();
    this.firestore
      .collection(COMPANIES_COLLECTION, (ref) =>
        ref.where('companyBrokerHelper', OP_EQUALS, this.userService?.loggedUser.id)
      )
      .get()
      .pipe(
        map((actions) =>
          actions.docs.map((doc) => {
            const data: any = doc.data();
            data.id = doc.id;
            return data;
          })
        ),
        concatMap((companies) => {
          return zip(
            ...companies.map((company) => {
              return this.findUserResponsible(company).pipe(
                map(({ leadName, leadUserId }) => {
                  company.leadName = leadName;
                  company.leadUserId = leadUserId;
                  return company;
                })
              );
            })
          );
        })
      )
      .subscribe({
        next: (resp: any) => {
          this.spinner.hide();
          this.loadingEmployees = false;
          this.companies = resp;
        },
        error: (err) => {
          this.spinner.hide();
          this.loadingEmployees = false;
          console.error('Error:', err);
        },
      });
  }

  private findUserResponsible(company: any) {
    return this.firestore
      .collection(USERS_COLLECTION, (ref) => ref
        .where('companyId', OP_EQUALS, company.id)
        .where('companyResponsible', OP_EQUALS, true)
      )
      .get()
      .pipe(
        map((actions) =>
          actions.docs.map((doc) => {
            const data: any = doc.data();
            data.id = doc.id;
            return data;
          })
        ),
        map((users) => {
          if (users.length === 0) {
            return {
              leadName: '',
              leadUserId: '',
            };
          }
          return {
            leadName: `${users[0].firstName} ${users[0].lastName}`,
            leadUserId: users[0].id,
          };
        })
      );
  }

  onSelectCompany(row: any) {
    this.navigate(['/helper/broker', row.id]);
  }

  onLogout() {
    this.spinner.show();
    this.auth
      .signOut()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this.spinner.hide();
          this.navigate(['/auth']);
        },
        error: () => {
          this.spinner.hide();
        }
      });
  }
}
